import React from 'react';
import ReactDOM from 'react-dom';
import 'quill/dist/quill.snow.css';
import "antd/dist/antd.css";
import './index.scss';
import './style-guide.scss';
import App from './App';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { PersistGate } from 'redux-persist/integration/react';
import './configs';
import ReactGA from 'react-ga';
import configureStore from './store';
const { store, persistor } = configureStore();

ReactGA.initialize('G-SHBEXDGW74'); // Add your ID

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
